<template>
    <nav>
    <v-app-bar app class="d-print-none secondary" >
      <v-app-bar-nav-icon @click="toggleDrawer" class="primary--text" size="large" ref="menu-toggle-btn"></v-app-bar-nav-icon>
      <span class="primary--text text--lighten-1">
        <span class="headline">vFeed</span>
        <span class="headline font-weight-light">{{$t('Console')}}</span>
      </span>
      <v-spacer></v-spacer>
        <span class="headline mx-2 primary--text text--lighten-1">{{profile.name}}</span>
        <img class="farm-logo-img mx-3"
        v-if="profile.logoURL"
        :src="profile.logoURL"
        />
    </v-app-bar>

    <v-navigation-drawer app :value="drawer" @input="setDrawer"
        v-if="isLoggedIn" class="d-print-none"
        :class="{'blue-grey darken-3': $vuetify.theme.dark,  'brown lighten-3': !$vuetify.theme.dark}"
        :right="isRtl"
        >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn fab fixed left text v-on="on" to="/settings">
            <v-icon>mdi-cogs</v-icon>
          </v-btn>
        </template>
        <span>{{$t('User Settings')}}</span>
      </v-tooltip>

      <v-tooltip bottom allow-overflow>
        <template v-slot:activator="{ on }">
          <v-btn fab fixed right text v-on="on" to="/equipments">
            <v-icon>mdi-tractor</v-icon>
          </v-btn>
        </template>
        <span>{{$t('Vehicle Information')}}</span>
      </v-tooltip>

      <v-img height="100px" contain src="../assets/vFeedLogoLg.png" class="mt-4"/>
      <v-list nav rounded>
        <v-subheader class="primary--text text--lighten-1">{{profile.name}}</v-subheader>
        <!-- <v-divider></v-divider> -->
        <v-list-item v-for="link in links" :key="link.text"
          router :to="link.route"
          active-class="green--text"
          >
          <v-list-item-action>
            <v-icon>{{link.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class=" px-3">{{$t(link.text)}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group prepend-icon="mdi-view-list">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class=" px-2">{{$t('Reports')}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item dense class="mx-2"
            v-for="report in reports" :key="report.text" router :to="report.route">
            <v-list-item-action>
              <v-icon>{{report.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-title class=" px-3">
              {{report.text}}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item @click="signOut" dense>
          <v-list-item-action>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class=" px-3">{{$t('Sign Out')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      links: [
        { icon: "mdi-view-dashboard", text: this.$i18n.t('Dashboard'), route: "/dashboard" },
        { icon: (Math.round(Math.random()) == 1 ? "mdi-corn" : "mdi-barley"),
          text: this.$i18n.t('Manage Feeds'), route: "/feeds" },
        { icon: "mdi-cow", text: this.$i18n.t('Manage Groups'), route: "/groups" },
        { icon: "mdi-silo", text: this.$i18n.t('Manage TMRs'), route: "/tmrs" },
        { icon: "mdi-tractor", text: this.$i18n.t('Manage Wagons'), route: "/wagons" },
        { icon: "mdi-flask-empty", text: this.$i18n.t('Manage Recipe'), route: "/recipe" },
        // { icon: "mdi-checkbox-multiple-marked-outline", text: this.$i18n.t('Inventory Adjustments'), route: "/inventory" },
      ],
      reports: [
        { icon: "mdi-account-cowboy-hat", text: this.$i18n.t('Wagons Report'), route: "/report-wagons" },
        { icon: "mdi-tractor", text: this.$i18n.t('Delivery Report'), route: "/report-delivery" },
        { icon: "mdi-layers-triple", text: this.$i18n.t('Material Used Report'), route: "/report-materials" },
        { icon: "mdi-layers-triple", text: this.$i18n.t('Inventory Transactions'), route: "/report-transactions" },
      ],
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch("logoutUser");
    },
    toggleDrawer() {
      this.$store.dispatch("setDrawerState");
    },
    setDrawer(e) {
      this.$store.dispatch("setDrawerState", e);
    }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.getUser
    },
    profile: function() {
      return this.$store.getters.getProfile
    },
    isRtl: function() {
      //make drawer on right for he locale
      return this.$i18n.locale == "he";
    },
    drawer: function () {
      return this.$store.getters.getDrawerState;
    }
  },
  watch: {
    isLoggedIn(newValue) {
      if (!newValue)
        this.$router.replace({name: "login"});
    }
  }
}
</script>

<style>
  .logo-img {
    display: inline-block;
    width: 100px;
    margin: 0px;
    padding: 0px;
  }
  .farm-logo-img {
    display: inline-block;
    max-height: 60px;
    width: auto;
    margin-left: 10px;
    align-self: center;
  }
  .v-btn--absolute.v-btn--right, .v-btn--fixed.v-btn--right {
    right: 2px !important;
  }
</style>
